var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA03Video(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.99 28.99",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0089fb;}.cls-2,.cls-3{fill:none;stroke:#0089fb;}.cls-2{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.29px;}.cls-3{stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.22 9.07 15.85 9.93 14.02 10.87 13.92 12.92 11.22 9.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.94,
    y1: 8.86,
    x2: 9.94,
    y2: 20.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20.98,
    y1: 14.44,
    x2: 14.1,
    y2: 10.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.94,
    y1: 20.71,
    x2: 20.98,
    y2: 14.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1,
    y: 1,
    width: 26.99,
    height: 26.99,
    rx: 2.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA03Video);
export default __webpack_public_path__ + "static/media/A03_Video.b9c7665144ed5ad3b0865a5f5d58292a.svg";
export { ForwardRef as ReactComponent };